import StaticLayout from 'common/Layout/StaticLayout';
import { Text } from 'common/styles';
import { __t } from 'common/i18n';
import ContactInfo from 'common/ContactInfo';
// import TicketForm from 'common/TicketForm';
import Seo, { SITE_URL } from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';
import Head from 'next/head';
import { safeJsonLd } from 'common/utils/safeJsonLd';

const contactSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'تماس با ما | فیلم‌نت',
  url: `${SITE_URL}/contact-us`,
  mainEntity: {
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    contactPoint: [{
      '@type': 'ContactPoint',
      telephone: '+982158172000',
      contactType: 'customer service',
      email: 'contact@filmnet.ir',
      availableLanguage: 'Persian',
      areaServed: 'IR',
    }],
  },
};

export default function ContactUs() {
  return <>
    <Seo
      title={`${__t('static_siteName')} | ${__t('contact.us.title')}`}
      description="برای تماس با پشتیبانی فیلمنت از طریق تلفن، ایمیل یا چت آنلاین می‌توانید با ما در ارتباط باشید. پاسخگوی سوالات و مشکلات شما هستیم."
      path="/contact-us"
    />
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonLd(contactSchema) }} />
    </Head>
    <Breadcrumb items={[
      { name: __t('common.home'), url: '/' },
      { name: __t('contact.us.title'), url: '/contact-us' },
    ]} />
    <StaticLayout cover="/static/images/static_pages/contact_us_cover_img.jpg" title={__t('contact.us.title')}>
      <Text variant="body1" mb={4} align="center">{__t('contact.us.page_description')}</Text>
      {/* <Paper mb={7}>
        <TicketForm />
      </Paper> */}
      <ContactInfo faq IconColor='#ffffff' />
    </StaticLayout>
  </>;
}
